import CryptoJS from "react-native-crypto-js";

const key = CryptoJS.enc.Utf8.parse('9666778424519046');
const iv = CryptoJS.enc.Utf8.parse('9666778424519046');

export function Encrypt(text){
    // return text
    return CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), key,
    {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString();
}

export function Decrypt(text){
    // return text
    return CryptoJS.AES.decrypt(CryptoJS.enc.Utf8.parse(text), key,
    {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString();
}